import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = null as any;

const hasActividadesGrupalesStateSlice = createSlice({
	name: 'hasActividadesGrupalesState',
	initialState,
	reducers: {
		setHasActividadesGrupalesState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setHasActividadesGrupalesState } = hasActividadesGrupalesStateSlice.actions;

export default hasActividadesGrupalesStateSlice.reducer;
